import EA from 'helpers/init';
import LocomotiveScroll from 'locomotive-scroll';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import gsap from 'gsap';

gsap.registerPlugin(ScrollTrigger);

export let scroller;

export default EA.Methods.locomotiveScroll = () => {
    scroller = new LocomotiveScroll({
        smooth: true,
        smoothMobile: true,
    });

    gsap.ticker.add(() => {
        ScrollTrigger.update();
    });

    ScrollTrigger.refresh();
};
